export const REQUEST_MAX_BORROW = 'requestMaxBorrow';
export const SET_MAX_BORROW = 'setMaxBorrow';

export const REQUEST_QUICK_LMI = 'requestQuickLmi';
export const SET_QUICK_LMI = 'setQuickLmi';

export const REQUEST_LISTING_INFO = 'requestListingInfo';
export const SET_LISTING_INFO = 'setListingInfo';
